import * as React from 'react';
var CascaderContext = /*#__PURE__*/React.createContext({
  changeOnSelect: false,
  expandTrigger: 'click',
  fieldNames: null,
  expandIcon: null,
  loadingIcon: null,
  loadData: null,
  dropdownMenuColumnStyle: null,
  search: null
});
export default CascaderContext;